export function findParentByClass(element: HTMLElement | null, className: string): HTMLElement | null {
	if (!element || typeof className !== 'string') {
		return null;
	}

	// Dodajemy kropkę przed nazwą klasy, aby dopasować selektor CSS
	return element.closest(`.${className}`);
}
